import { render, staticRenderFns } from "./YPlayer.vue?vue&type=template&id=53b3544b&scoped=true"
import script from "./YPlayer.vue?vue&type=script&lang=js"
export * from "./YPlayer.vue?vue&type=script&lang=js"
import style0 from "./YPlayer.vue?vue&type=style&index=0&id=53b3544b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b3544b",
  null
  
)

export default component.exports